/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import FullPageLayout from "../../../../../templates/FullPageLayout";
import Header from "./Components/Header";
import { NeedHelp } from "../../../../../atoms/CustomIcons";
import { Card, Col, Row } from "antd";
import { useAppDispatch, useAppSelector } from "../../../../../config/hooks";
import EstimateSidebar from "./Components/Sidebar";
import EstimateServices from "./Components/EstimateServices";
import EmptyCard from "../../../../../atoms/EmptyCard";
import { SubServiceType } from "../../../../PotentialDeals/ducks/types";
import {
  getProposalById,
  getProposalDetailById,
  getProposalFormData,
} from "../../../../PotentialDeals/ducks/actions";
import EstimateDropDown from "./Components/Dropdown";
import { getContractById } from "../../../ducks/actions";

export default function ContractEstimate() {
  const [loading, setLoading] = useState(false);

  const dispatch = useAppDispatch();
  const locationUrl = window.location.pathname;
  const pathSegments = locationUrl.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const estimateId = pathSegments[pathSegments.length - 2];
  const proposalId = pathSegments[pathSegments.length - 3];
  const contractId = pathSegments[pathSegments.length - 4];
  // const [activeId, setActiveId] = useState<null | string>(null);
  const [activeServiceLineId, setActiveServiceLineId] = useState<null | string>(
    null
  );
  const [combineDropDown, setCombineDropDown] = useState<any[]>([]);
  const [activeRecord, setActiveRecord] = useState<SubServiceType | null>(null);
  const [activeType, setActiveType] = useState<null | string>(null);
  const [activeServiceId, setActiveServiceId] = useState<null | string>(null);
  const [textAreaContent, setTextAreaContent] = useState("");
  const proposalDetailData = useAppSelector(
    (state) => state?.potentialDeal?.proposalDetailData
  );

  const proposalData = useAppSelector(
    (state) => state?.potentialDeal?.proposalData
  );

  const estimateFormData = useAppSelector(
    (state) => state?.potentialDeal?.estimateFormData
  );

  const contractDetailData = useAppSelector(
    (state) => state?.contract?.contractDetailData
  );

  useEffect(() => {
    if (companyId) {
      dispatch(getProposalFormData(companyId));
    }
  }, [dispatch, companyId]);

  const [selectedServiceIds, setSelectedServiceIds] = useState<string[]>([]);
  const [groupedData, setGroupedData] = useState<any[]>([]);

  useEffect(() => {
    if (proposalId) {
      dispatch(getProposalById(proposalId));
      dispatch(getProposalDetailById(proposalId));
    }
  }, [proposalId, dispatch]);

  useEffect(() => {
    if (proposalDetailData?.summary) {
      setTextAreaContent(proposalDetailData?.summary || "");
    }
  }, [proposalDetailData]);

  useEffect(() => {
    if (contractId) {
      dispatch(getContractById(contractId));
    }
  }, [dispatch, contractId]);

  return (
    <FullPageLayout loading={loading || proposalData?.loader}>
      <div className="estimateWrapper" style={{ position: "relative" }}>
        <Header
          companyId={companyId}
          contractId={contractId}
          btnText1="Need help?"
          btnIcon1={<NeedHelp />}
          btnText2="Proposal doc"
          setLoading={setLoading}
          dealsDetailData={contractDetailData?.data}
          proposalDetailData={proposalDetailData}
          addProposal={true}
          proposalId={proposalId}
          dealId={estimateId}
        />

        <Card className="estimateCard">
          <Row gutter={16} wrap={false}>
            <Col flex="auto">
              <Card className="estimateCardInner">
                <div className="estimateLeftHeader">
                  <EstimateDropDown
                    estimateFormData={estimateFormData}
                    proposalData={proposalData}
                    setGroupedData={setGroupedData}
                    combineDropDown={combineDropDown}
                    setCombineDropDown={setCombineDropDown}
                    setSelectedServiceIds={setSelectedServiceIds}
                  />
                </div>

                {groupedData?.length > 0 ? (
                  <div className="estimateWrap">
                    {groupedData?.map((groupData: any, groupIndex: number) => {
                      return (
                        <EstimateServices
                          key={groupIndex}
                          setActiveRecord={setActiveRecord}
                          setActiveType={setActiveType}
                          groupData={groupData}
                          groupedData={groupedData}
                          groupIndex={groupIndex}
                          setGroupedData={setGroupedData}
                          companyId={companyId}
                          apiData={proposalData?.data}
                          setActiveServiceLineId={setActiveServiceLineId}
                          setActiveServiceId={setActiveServiceId}
                          selectedServiceIds={selectedServiceIds}
                          setSelectedServiceIds={setSelectedServiceIds}
                        />
                      );
                    })}
                  </div>
                ) : (
                  <div className="empty_wrap estimateEmptyCard">
                    <EmptyCard
                      imageHeight={200}
                      title="No services selected yet"
                      description={
                        <>
                          You haven’t added any services yet. Search for a
                          service or
                          <br /> Choose from catalogue to find what you need.
                        </>
                      }
                      image="/images/empty-icons/no-archived.svg"
                    />
                  </div>
                )}
              </Card>
            </Col>
            <Col flex="328px">
              <EstimateSidebar
                setLoading={setLoading}
                setTextAreaContent={setTextAreaContent}
                textAreaContent={textAreaContent}
                activeRecord={activeRecord}
                groupedData={groupedData}
                newEstimate={true}
                activeServiceId={activeServiceId}
                singleGroupData={groupedData?.find(
                  (e) => e?.service_line_id === activeServiceLineId
                )}
                activeType={activeType}
                resetSidebar={() => {
                  setActiveRecord(null);
                  setActiveType(null);
                  setActiveServiceLineId(null);
                }}
              />
            </Col>
          </Row>
          {proposalDetailData?.status === "sent_to_production" && (
            <div className="overlayForSendProduction"></div>
          )}
        </Card>
      </div>
    </FullPageLayout>
  );
}
